// extracted by mini-css-extract-plugin
export default {"faqAgentCooperation":"faqAgentCooperation_R38KF","title":"title_hyEvo","content":"content_yNENJ","button":"button_UMWO8"};